
import { config } from '../../../config.js';

export const API_MSHospitalBaseUrl = "https://dhanwanthralayatestapi.convenientcare.life/";
export const API_MOPCRMBASEURL = config.API_MOPCRMBASEURL;

// export const API_MSHospitalBaseUrl = "https://hms-devapi.mocerohealth.in/";

// export const API_MOPCRMBASEURL = "https://localhost:7297/";

//  export const API_MOPCRMBASEURL = "https://crmmedwayapi.convenientcare.life/";

// export const API_MOPCRMBASEURL = "https://mopcrmapi.convenientcare.life/"

// export const API_MOPCRMBASEURL = "https://mopcrmapitest.convenientcare.life/";

// export const API_MOPCRMBASEURL = "https://democrmapi.convenientcare.life/";

// export const API_MOPCRMBASEURL = "https://wellcubecrmtestapi.mocerohealth.com/";

// export const API_MOPCRMBASEURL = "https://mopcrmapi.convenientcare.life/";

//  export const API_MOPCRMBASEURL = "https://avittamhomesapi.convenientcare.life/";

// export const API_MOPCRMBASEURL = "https://crmapi.medwayhospitals.com/";

// export const API_MOPCRMBASEURL = "https://crmapi.avittamhomes.com/";

// export const API_MOPCRMBASEURL = "https://crmapi.mocerohealth.com/";

// export const API_MOPCRMBASEURL = "https://shabdhamcrmapi.convenientcare.life/";


